import {
    MailOutlined,
    PieChartOutlined, SettingOutlined,
} from '@ant-design/icons';
import {Menu} from 'antd';
import {Link, useLocation, useNavigate} from "react-router-dom";
import cx from 'classnames';
import st from './Sidenav.module.scss';
import grand from '../../assets/images/grand.png';


const items = [
    {
        key: 'sub0',
        label: 'მოთამაშეები',
        icon: <PieChartOutlined/>,
        children: [
            {
                key: '/players',
                label: <Link to="/players">აქტიური</Link>,
            },
            {
                key: '/all-players',
                label: <Link to="/all-players">სრული</Link>,
            },
            {
                key: '/dashboard',
                label: <Link to="/dashboard">სტატისტიკა</Link>,
            },
        ],
    },
    {
        key: 'sub1',
        label: 'მართვა',
        icon: <MailOutlined/>,
        children: [
            {
                key: '/coaches',
                label: <Link to="/coaches">მწვრთნელები</Link>,
            },
            {
                key: '/teams',
                label: <Link to="/teams">გუნდები</Link>,
            },
            {
                key: '/statuses',
                label: <Link to="/statuses">სტატუსები</Link>,
            },
            {
                key: '/payments',
                label: <Link to="/payments">გადახდები</Link>,
            },
        ],
    },
    {
        key: '/settings',
        label: 'პარამეტრები',
        icon: <SettingOutlined/>,
        children: [
            {
                key: '/billings',
                label: <Link to="/billings">დარიცხვები</Link>,
            },
            {
                key: '/change-password',
                label: (
                    <Link to="/change-password">
                        პაროლის შეცვლა
                    </Link>
                ),
            },],
    },
];

const Sidenav = ({menuIsCollapsed}) => {
    const location = useLocation();
    const selectedKey = [location.pathname];

    return (
        <div
            className={cx(st.sidenav, {[st.sidenavCollapsed]: menuIsCollapsed})}
        >
            <div>
                <img height='40px' src={grand} alt="grand" className={st.logo}/>
            </div>
            <Menu
                selectedKeys={selectedKey}
                defaultOpenKeys={['sub0', 'sub1', 'sub2']}
                mode="inline"
                theme="dark"
                inlineCollapsed={menuIsCollapsed}
                items={items}
            />
        </div>
    );
}

export default Sidenav;